import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
import { io } from 'socket.io-client';
import { useAudioPlayer } from 'expo-audio';
import { AuthContext } from './AuthContext';
import CONFIG from '../config/Config';

export const SocketContext = createContext();

const HATIRLATMA_SURESI = 30000; // 30 saniye - bekleyen sipariş hatırlatma aralığı

export function SocketProvider({ children }) {
  const { userToken } = useContext(AuthContext);
  const socketRef = useRef(null);
  const hydratedRef = useRef(false);
  const siparislerRef = useRef([]);
  const playRef = useRef(null);

  const player = useAudioPlayer(require('../../assets/new_order.mp3'));

  const [siparisler, setSiparisler] = useState([]);
  const [connected, setConnected] = useState(false);

  // Ref'leri güncel tut
  useEffect(() => {
    siparislerRef.current = siparisler;
  }, [siparisler]);

  const playNewOrderSound = () => {
    try {
      player.seekTo(0);
      player.play();
      console.log('[SOCKET] Ses çalındı');
    } catch (e) {
      console.log('[SOCKET] Ses çalma hatası:', e?.message);
    }
  };

  // playRef her zaman güncel fonksiyonu tutar
  useEffect(() => { playRef.current = playNewOrderSound; });

  // Hatırlatma sistemi: İşlenmemiş siparişler varsa periyodik zil çalar
  useEffect(() => {
    const interval = setInterval(() => {
      const bekleyen = siparislerRef.current.filter(s => !s._durum);
      if (bekleyen.length > 0) {
        console.log(`[SOCKET] ${bekleyen.length} bekleyen sipariş - hatırlatma zili`);
        if (playRef.current) playRef.current();
      }
    }, HATIRLATMA_SURESI);

    return () => clearInterval(interval);
  }, []);

  // Sipariş durumunu güncelle (kabul/red)
  const siparisOnayla = (siparisId, durum) => {
    setSiparisler(prev => prev.map(s =>
      s.siparisId === siparisId ? { ...s, _durum: durum } : s
    ));
    console.log(`[SOCKET] Sipariş #${siparisId} durumu: ${durum}`);
  };

  const fetchPendingSiparisler = async () => {
    try {
      const res = await fetch(`${CONFIG.API_BASE_URL}/pending-orders`, {
        headers: { 'x-internal-secret': '190717hasancinaralti', 'X-App-Env': CONFIG.ENV }
      });
      const data = await res.json();

      console.log('[SOCKET] Pending siparişler çekildi:', Array.isArray(data.siparisler) ? data.siparisler.length : 'Geçersiz veri');
      console.log('[SOCKET] Gelen veri örneği:', Array.isArray(data.siparisler) && data.siparisler.length > 0 ? data.siparisler[0] : 'Yok');

      if (data.success && Array.isArray(data.siparisler)) {
        setSiparisler(prev => {
          const merged = [...prev];
          data.siparisler.forEach(s => {
            if (!merged.find(m => m.siparisId === s.siparisId)) merged.unshift(s);
          });
          return merged;
        });
      }
    } catch (e) {
      console.log('[SOCKET] Pending fetch hatası:', e?.message);
    }
  };

  useEffect(() => {
    if (!userToken) return;

    hydratedRef.current = false;

    const socket = io(CONFIG.SOCKET_URL, {
      transports: ['websocket'],
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 10000,
      timeout: 20000,
    });

    socketRef.current = socket;

    socket.on('connect', async () => {
      setConnected(true);
      await fetchPendingSiparisler();
      hydratedRef.current = true;
    });

    socket.on('disconnect', () => {
      setConnected(false);
    });

    socket.on('new_order', (siparis) => {
      let added = false;

      setSiparisler(prev => {
        const exists = prev.find(s => s.siparisId === siparis.siparisId);
        if (exists) return prev;
        added = true;
        return [siparis, ...prev];
      });

      if (added && hydratedRef.current) {
        playNewOrderSound();
      }
    });

    socket.on('pending_orders', (list) => {
      setSiparisler(Array.isArray(list) ? list : []);
    });

    return () => {
      socket.disconnect();
      socketRef.current = null;
    };
  }, [userToken]);

  const siparisGuncelle = (siparisId) => {
    setSiparisler(prev => prev.filter(s => s.siparisId !== siparisId));
  };

  return (
    <SocketContext.Provider value={{ siparisler, connected, siparisGuncelle, siparisOnayla, fetchPendingSiparisler }}>
      {children}
    </SocketContext.Provider>
  );
}
